// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const fromExtractionSectionBodyMax = 20000;

export const fromExtractionSectionKeyMax = 80;

export const fromExtractionSectionTitleOneMax = 200;

export const FromExtractionSection = zod.object({
  "audience": zod.enum(['internal', 'shareable']),
  "body": zod.string().min(1).max(fromExtractionSectionBodyMax),
  "key": zod.string().min(1).max(fromExtractionSectionKeyMax),
  "title": zod.union([zod.string().max(fromExtractionSectionTitleOneMax),zod.null()]).optional()
});

export type FromExtractionSection = zod.input<typeof FromExtractionSection>;
export type FromExtractionSectionOutput = zod.output<typeof FromExtractionSection>;
